import React, { useMemo, useState, useEffect } from 'react'
import { Breadcrumb, Row, Col, Spin, Alert, Button, Modal, message } from 'antd'       
import { useNavigate, useSearchParams, Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useGwGoodsUpdateQuery, useGwGoodsGuigeListQuery, useGetqiyedingdanQuery, useShangpingdingdanAddMutation } from '../store/ReactWebSiteApi'
import styles from './WebGoodsSubTypeGoodsDesc.module.css'
import WebMain from './WebMain'
import { TaobaoCircleOutlined, ShoppingOutlined, BankOutlined, ExperimentOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
const IMG_BASE = '../api/assets/images/application/'

function parseImageFiles(item) {
  const raw = item?.eowg_image_file
  if (raw == null) return []
  if (Array.isArray(raw)) {
    return raw.map((s) => String(s).trim()).filter(Boolean)
  }
  return String(raw)
    .split(',')
    .map((s) => s.trim())
    .filter(Boolean)
}

function toImgSrc(fileName) {
  if (!fileName) return ''
  return `${IMG_BASE}${fileName}`
}

const MAX_THUMBS = 5

function WebGoodsSubTypeGoodsDesc(props) {
    const [param] = useSearchParams()
    const firmLogin = useSelector((state) => state.firmLogin)
    const eowg_id = param.get('eowg_id')
    const navigate = useNavigate()
    const [activeIndex, setActiveIndex] = useState(0)
    const [selectedGuige, setSelectedGuige] = useState(null)

    const {
        data: detailData,
        isSuccess: detailOk,
        isLoading: detailLoading,
        isFetching: detailFetching,
        isError: detailReqError,
    } = useGwGoodsUpdateQuery({ eowg_id: eowg_id }, { skip: !eowg_id })

    const { data: guigeData, isSuccess: guigeOk } = useGwGoodsGuigeListQuery(
        { eowgg_eowg_id: eowg_id },
        { skip: !eowg_id }
    )

    const merged = useMemo(() => {
        if (!eowg_id) return null
        if (detailOk && detailData?.Status === 'success' && detailData?.Result) {
            return { eowg_id, ...detailData.Result }
        }
        return null
    }, [eowg_id, detailOk, detailData])

    const fileNames = useMemo(() => parseImageFiles(merged), [merged])
    const urls = useMemo(() => fileNames.map(toImgSrc), [fileNames])
    const thumbFiles = useMemo(() => fileNames.slice(0, MAX_THUMBS), [fileNames])

    useEffect(() => {
        setActiveIndex(0)
    }, [merged?.eowg_id])

    useEffect(() => {
        if (activeIndex >= urls.length && urls.length > 0) {
        setActiveIndex(0)
        }
    }, [urls.length, activeIndex])

    const guigeList = useMemo(() => {
        if (!guigeOk || guigeData?.Status !== 'success' || !Array.isArray(guigeData?.Result)) {
        return []
        }
        return guigeData.Result
    }, [guigeOk, guigeData])

    useEffect(() => {
        if (guigeList.length === 0) {
        setSelectedGuige(null)
        return
        }
        setSelectedGuige((prev) => {
        if (prev && guigeList.some((g) => g.eowgg_id === prev.eowgg_id)) {
            return prev
        }
        return guigeList[0]
        })
    }, [guigeList, merged?.eowg_id])

    const detailHtml = merged?.eowg_content
    const processedDetailHtml = useMemo(() => {
        if (typeof detailHtml !== 'string') return ''
        return detailHtml.replace(/<img([^>]*)data-href="([^"]*)"([^>]*)\/?>/g, (match, pre, href, post) => {
        const link = (href || '').trim()
        if (link) {
            return `<a href="${link}" target="_blank" rel="noopener noreferrer" style="cursor:pointer;display:inline-block;"><img${pre}${post} data-href="${link}" /></a>`
        }
        return `<img${pre} data-href="${href}"${post} />`
        })
    }, [detailHtml])

    const detailBusinessFail =
        detailOk && (detailData?.Status !== 'success' || !detailData?.Result)
    const detailPending =
        Boolean(eowg_id) &&
        !merged &&
        !detailBusinessFail &&
        !detailReqError &&
        (detailLoading || detailFetching)

    const mainSrc = urls[activeIndex] || urls[0] || ''
    const firmLoginInfo = useMemo(() => {
        try {
            const raw = localStorage.getItem('firmLoginInfo')
            return raw ? JSON.parse(raw) : null
        } catch (error) {
            return null
        }
    }, [])
    const ddQyId = firmLoginInfo?.byxkh_yh_kh_id || firmLoginInfo?.qy_id
    // 免费试用查询：Hook 必须固定在组件顶层调用，使用 skip 控制是否请求
    const { data: freeTrialData, refetch: refetchFreeTrial } = useGetqiyedingdanQuery(
        { dd_qy_id: ddQyId,dd_eowg_id:eowg_id,},
        { skip: !ddQyId || !eowg_id }
    )
    const [submitTrialOrder] = useShangpingdingdanAddMutation()

    if (!eowg_id) {
        return (
            <WebMain selectedKeys='goods'>
                <div className={styles.wrap} style={{ minHeight: '50vh', padding: 24 }}>
                    <Alert type="warning" showIcon message="缺少商品参数" description="请从商品列表重新进入。" />
                </div>
            </WebMain>
        )
    }

    if (!merged) {
        return (
            <WebMain selectedKeys='goods'>
                <div
                    className={styles.wrap}
                    style={{
                        minHeight: '60vh',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        padding: 24,
                    }}
                >
                    {detailPending ? (
                        <Spin spinning tip="加载商品信息…" size="large">
                            <div style={{ minHeight: 120, minWidth: 280 }} />
                        </Spin>
                    ) : (
                        <Alert
                            type="error"
                            showIcon
                            message="商品加载失败"
                            description={detailReqError ? '网络异常，请稍后重试。' : '未找到该商品或已下架。'}
                        />
                    )}
                </div>
            </WebMain>
        )
    }
    //免费试用
    const hasExistingTrialOrder = (apiData) => {
        const list = apiData?.Result
        if (Array.isArray(list)) return list.length > 0
        if (list && typeof list === 'object') return Object.keys(list).length > 0
        return false
    }
    const checkFreeTrial = async () => {
        if (!ddQyId) {
            message.warning('请先登录企业账号')
            navigate('/FirmLogin', { state: { prelocation: { pathname: window.location.pathname } } })
            return
        }
        let latest = freeTrialData
        try {
            const refreshed = await refetchFreeTrial()
            latest = refreshed?.data ?? latest
        } catch (error) {
            message.error('校验订单失败，请稍后重试')
            return
        }

        if (hasExistingTrialOrder(latest)) {
            Modal.confirm({
                title: '提示',
                content: '您已有该系统账号，具体请联系客服！',
                okText: '确认',
                cancelButtonProps: { style: { display: 'none' } },
                onOk: () => navigate('/FirmOrderList'),
            })
            return
        }

        try {
            const res = await submitTrialOrder({
                // TODO: 具体参数请按后端接口要求补充
                'dd_eowg_id': eowg_id,
                'dd_eowg_name': merged.eowg_name,
                'dd_eowgg_id': selectedGuige?.eowgg_id,
                'dd_eowgg_name': selectedGuige?.eowgg_name,
                'dd_byxkh_id': ddQyId,
                'dd_byxkh_name': firmLoginInfo.byxkh_yh_kh_name,
                'dd_xf_date': dayjs().format('YYYY-MM-DD'),
                'dd_dq_date': dayjs().add(1, 'month').format('YYYY-MM-DD'),
                'dd_xf_amount': '0.00',
                'dd_xf_num': 1,
                'dd_content': '免费试用',
                'dd_uid': firmLogin.byxkh_yh_id,
                'dd_uname': firmLogin.byxkh_yh_name,
                'dd_qy_id': ddQyId,
                'dd_qy_name': firmLoginInfo.byxkh_yh_kh_name,
                'dd_database': '1',
                'dd_eowgt_id': merged.eowgt_id,
                'dd_eowgt_name': merged.eowgt_name,
                'dd_eowgts_id': merged.eowgts_id,
                'dd_eowgts_name': merged.eowgts_name
            })
            if (res?.data?.Status === 'success') {
                Modal.confirm({
                    title: '提示',
                    content: '试用订单新增成功，点击确认按钮跳转到订单列表，获取试用账号！',
                    okText: '确认',
                    cancelButtonProps: { style: { display: 'none' } },
                    onOk: () => navigate('/FirmOrderList'),
                })
            } else {
                message.error('提交失败，请稍后重试')
            }
        } catch (error) {
            message.error('提交失败，请稍后重试')
        }
    }
    return (
        <WebMain selectedKeys='goods'>
            <Row>
                <Col span={6}></Col>
                <Col span={12} style={{padding:'10px 0'}}>
                    <Breadcrumb>
                        <Breadcrumb.Item>
                            <Link
                                to={`/WebGoods?${new URLSearchParams({ eowgt_id: merged.eowgt_id ?? '' }).toString()}`}
                            >
                                {merged.eowgt_name}
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>
                            <Link
                                to={`/WebGoods?${new URLSearchParams({
                                    eowgt_id: merged.eowgt_id ?? '',
                                    eowgts_id: merged.eowgts_id ?? '',
                                }).toString()}`}
                            >
                                {merged.eowgts_name}
                            </Link>
                        </Breadcrumb.Item>
                        <Breadcrumb.Item>{merged.eowg_name}</Breadcrumb.Item>
                    </Breadcrumb>
                </Col>
                <Col span={6}></Col>
            </Row>
            <div className={styles.wrap}>
                <div className={styles.content}>
                    <div className={styles.topRow}>
                        <div className={styles.gallery}>
                        {thumbFiles.length > 0 ? (
                            <div className={styles.thumbs}>
                            {thumbFiles.map((file, i) => (
                                <img
                                key={`${file}-${i}`}
                                src={toImgSrc(file)}
                                alt=""
                                className={`${styles.thumb} ${i === activeIndex ? styles.thumbActive : ''}`}
                                onClick={() => setActiveIndex(i)}
                                />
                            ))}
                            </div>
                        ) : null}
                        <div>
                            {mainSrc ? (
                            <img className={styles.mainImg} src={mainSrc} alt={merged.eowg_name || ''} />
                            ) : (
                            <div className={styles.mainImg} style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#bfbfbf' }}>
                                暂无图片
                            </div>
                            )}
                        </div>
                        </div>

                        <div className={styles.info}>
                            <h2 className={styles.title}>{merged.eowg_name || '商品'}</h2>
                            {merged.eowg_sub_name ? <div className={styles.subTitle}>{merged.eowg_sub_name}</div> : null}

                            <div className={styles.specLabel}>价格</div>
                            {guigeList.length > 0 ? (
                                <div className={styles.specList}>
                                    {guigeList.map((g) => {
                                        const active = selectedGuige?.eowgg_id === g.eowgg_id
                                        return (
                                        <div
                                            key={g.eowgg_id}
                                            role="button"
                                            tabIndex={0}
                                            className={`${styles.specRow} ${active ? styles.specRowActive : ''}`}
                                            onClick={() => setSelectedGuige(g)}
                                            onKeyDown={(e) => {
                                            if (e.key === 'Enter' || e.key === ' ') setSelectedGuige(g)
                                            }}
                                        >
                                            <span className={styles.specName}>{g.eowgg_name || '规格'}</span>                                        
                                        </div>
                                        )
                                    })}
                                </div>
                            ) : (
                                <div className={styles.subTitle} style={{ marginBottom: 16 }}>
                                暂无规格，请联系客服
                                </div>
                            )}
                            <div style={{marginTop:'20px',display:'flex',justifyContent:'space-around'}}>
                                <Button 
                                    style={{ color: '#ff7a45', borderColor: '#ff7a45' }}
                               
                                    onClick={() => {window.open('https://shop237315218.taobao.com/?spm=a21n57.shop_search.0.0.1f5f523cQTiqg3')}} 
                                    icon={<TaobaoCircleOutlined/>}
                                    size='large'
                                >淘宝下单</Button>
                                <Button 
                                    size='large'
                                    style={{color:'#ff4d4f',borderColor:'#ff4d4f'}}  
                                    onClick={() => {window.open('https://mall.jd.com/index-16913726.html?from=pc&cid=0')}} 
                                    icon={<ShoppingOutlined/>}
                                >京东下单</Button> 
                                <Button
                                    size="large"
                                    style={{color:'#52c41a', borderColor:'#52c41a'}} 
                                    onClick={() => { navigate('/TransferBuy') }}
                                    icon={<BankOutlined />}
                                >
                                    转账付款
                                </Button>
                                <Button
                                    size="large"
                                    style={{color:'#d50060',borderColor:'#d50060'}} 
                                    onClick={checkFreeTrial}
                                    icon={<ExperimentOutlined />}
                                >
                                    免费试用
                                </Button>
                           
                            </div>
                        </div>
                        
                    </div>

                    <div className={styles.detailSection}>
                        <div
                        className={`${styles.detailHtml} detail-html`}
                        dangerouslySetInnerHTML={{
                            __html: processedDetailHtml
                        }}
                        />
                    </div>
                </div>
            </div>
        </WebMain>
    )
}

export default WebGoodsSubTypeGoodsDesc
